import { render, staticRenderFns } from "./PrintPhotos.vue?vue&type=template&id=beab47e6&scoped=true&"
import script from "./PrintPhotos.vue?vue&type=script&lang=js&"
export * from "./PrintPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PrintPhotos.vue?vue&type=style&index=0&id=beab47e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beab47e6",
  null
  
)

export default component.exports